import PromotionListingPage from './promotion-list';

interface IVolumeDiscountPromo {}

const VolumeDiscountPromo: React.FunctionComponent<IVolumeDiscountPromo> = props => {
  return <PromotionListingPage promo={'VOLUME_DISC'} promoName="Volume Discount" />;
};

export default VolumeDiscountPromo;
